import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner, Card, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';
import snakeCaseKeys from 'snakecase-keys';
import { SimpleCenteredModal } from '../../components';
import RiskPreventionDocumentList from './RiskPreventionDocumentList';

import { sendAlert } from '../../actions/utils';
import {
  debounceIndexRiskPreventionDocumentRequest,
  updateRiskPreventionDocumentRequest,
  createRiskPreventionDocumentRequest,
  indexRiskPreventionDocumentRequest,
  destroyRiskPreventionDocumentRequest
} from '../../requests/riskPreventionDocuments';

import RiskPreventionDocumentForm from './RiskPreventionDocumentForm';
import RiskPreventionCustomsDataTable from './RiskPreventionCustomsDataTable';

const RiskPreventionDocumentIndex = () => {
  const [onRequest, setOnRequest] = useState(false);
  const [riskPreventionDocument, setRiskPreventionDocument] = useState([]);
  const [moreData, setMoreData] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const dispatch = useDispatch();

  const handleIndexRequest = () => {
    setOnRequest(true);
    debounceIndexRiskPreventionDocumentRequest({
      dispatch,
      params: {
        document_type: [
          'order_hygiene_safety',
          'labor_direction',
          'emergency_evaluation',
          'riohs_labor_inspection',
          'riohs_seremi'
        ],
        sort_column: 'document_type',
        sort_direction: 'asc'
      },
      successCallback: response => setRiskPreventionDocument(camelCaseRecursive(response.data.data)),
      callback: () => setOnRequest(false)
    });
  };

  const handleUpdateRequest = (values, setSubmitting) => {
    setOnRequest(true);
    const { document } = values.riskPrevention;
    const myParams = snakeCaseKeys(values);
    myParams.risk_prevention.document = document;

    updateRiskPreventionDocumentRequest(values.id, {
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => dispatch(sendAlert({ kind: 'success', message: 'Documento subido con éxito' })),
      callback: () => {
        setSubmitting(false);
        setOnRequest(false);
        setMoreData(!moreData);
      }
    });
  };

  const handleCreate = (values, setSubmitting) => {
    setSubmitting(true);

    const myParams = snakeCaseKeys(values);
    myParams.risk_prevention.document = values.riskPrevention.document;

    createRiskPreventionDocumentRequest({
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Documento creado con éxito' }));
        setModalShow(false);
        setMoreData(!moreData);
      },
      callback: () => setSubmitting(false)
    });
  };

  useEffect(handleIndexRequest, [moreData]);

  const riskPreventionConfig = {
    endpoints: {
      index: indexRiskPreventionDocumentRequest,
      update: updateRiskPreventionDocumentRequest,
      destroy: destroyRiskPreventionDocumentRequest
    },
    fieldName: 'risk_prevention',
    kind: 'customs'
  };

  return (
    <>
      {onRequest && (
        <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Row className="mt-4 mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          <h2 className="mb-0">Documentación Legal</h2>
        </Col>
        <Col md={2} className="mb-2 mb-md-0">
          <Button variant="primary" block onClick={() => setModalShow(true)}>
            Nuevo
          </Button>
        </Col>
      </Row>

      <Row className={`${onRequest && 'bg-opacity'}`}>
        <Col xs={12} className="yellow-table p-3">
          <Card className="shadow-sm">
            <Card.Body className="align-items-center">
              {riskPreventionDocument.map((doc, index) => (
                <RiskPreventionDocumentList
                  key={doc.id}
                  index={index}
                  doc={doc}
                  onSubmit={handleUpdateRequest}
                  setOnRequest={setOnRequest}
                />
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs={12} className="p-3">
          <h4 className="mb-3">Otros Documentos Legales</h4>
          <RiskPreventionCustomsDataTable moreData={moreData} setMoreData={setMoreData} config={riskPreventionConfig} />
        </Col>
      </Row>

      <SimpleCenteredModal
        title="Nuevo Documento"
        show={modalShow}
        onHide={() => setModalShow(false)}
        body={<RiskPreventionDocumentForm formRequest={handleCreate} action="new" fieldName="riskPrevention" />}
        size="lg"
      />
    </>
  );
};

export default RiskPreventionDocumentIndex;
